import React from 'react';

const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="bg d-flex justify-content-center">
      <div className="auth-page  d-flex justify-content-center align-items-center px-3 py-5">
        <div className="auth-container bg-white shadow-lg overflow-hidden">
          <div className="row g-0 h-100">
            <div className="col-md-8">
              <div className="auth-hero position-relative h-100 d-none d-md-block w-100">
                <img
                  src="/assets/images/Business-Meeting-in-Modern-Office.webp"
                  className="auth-hero-image w-100 h-100"
                  alt="Business Meeting"
                />

                <img
                  src="/assets/images/sidebarlogo.png"
                  className="auth-hero-logo position-absolute"
                  alt="Logo"
                />
              </div>
            </div>

            <div className="col-md-4">
              <div className="auth-card card d-flex flex-column px-lg-3 px-0 h-100 shadow-none">
                <div className="auth-card-body card-body d-flex align-items-lg-center py-5 py-lg-0 px-md-0 mt-4 mt-lg-0 px-4 ">
                  <div className="w-100">{children}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
